var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { Body, H3 } from "../Typography";
import Button from "../Button";
import PopUpWithImage from "../PopUpWithImage";
import Flex from "../Flex";
var CancellationPopup = /** @class */ (function (_super) {
    __extends(CancellationPopup, _super);
    function CancellationPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popup = null;
        return _this;
    }
    CancellationPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, onCancel = _a.onCancel, cancelButtonText = _a.cancelButtonText, onConfirm = _a.onConfirm, confirmButtonText = _a.confirmButtonText, headerText = _a.headerText, headerBody = _a.headerBody, cancelImage = _a.cancelImage;
        return (React.createElement(PopUpWithImage, { ref: function (c) {
                _this.popup = c;
            }, img: cancelImage, maxWidth: "650px" },
            React.createElement(H3, { marginBottom: true },
                React.createElement(FormattedMessage, { id: headerText })),
            React.createElement(Body, { small: true, marginBottom: 3 }, headerBody),
            React.createElement(Flex, { justifyContent: "flex-end" },
                React.createElement(Button, { tertiary: true, onClick: onCancel, marginRight: true }, cancelButtonText),
                React.createElement(Button, { primary: true, onClick: onConfirm }, confirmButtonText))));
    };
    CancellationPopup.defaultProps = {
        headerText: "perks.components.cancellationPopUp.headerText"
    };
    return CancellationPopup;
}(PureComponent));
export default CancellationPopup;
